// @index(!.mdx): export { default as ${variable} } from ${relpath};
export { default as GoogleIcon } from "./GoogleIcon";
